var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mb-4"},[_vm._v("Impressum")]),_c('b-card-text',[_c('b-img',{attrs:{"src":require("../assets/imprint.png"),"left":"","width":"250px","height":"125px","alt":"imprint"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }